import { render, staticRenderFns } from "./UserTypeList.vue?vue&type=template&id=479b0936&"
import script from "./UserTypeList.vue?vue&type=script&lang=js&"
export * from "./UserTypeList.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports